/**
 * Termly privacy banner —— 七横-合规
 * data-auto-block="on" 在用户 consent 前自动阻止 GA4/PostHog 加载（GDPR 合规）
 */
import { useEffect } from 'react';
import { getEnv } from '@/lib/env';

export default function Termly() {
  useEffect(() => {
    const uuid = getEnv().VITE_TERMLY_UUID;
    if (!uuid) return;

    const s = document.createElement('script');
    s.src = 'https://app.termly.io/embed.min.js';
    s.setAttribute('data-auto-block', 'on');
    s.setAttribute('data-website-uuid', uuid);
    document.head.appendChild(s);
  }, []);

  return null;
}
